import { DEFAULT_FORNITORE } from '../../data/fornitore'
import { VERSANTE, CONTO_IBAN } from '../../data/versanti';
import { plainStore } from '../../utils/safeStoring'

export const applyBaseConfig = () => {
    plainStore('infoFornitore', DEFAULT_FORNITORE);
    plainStore('savedFornitore', 'partita-iva');
    plainStore('infoVersante', VERSANTE);
    plainStore('infoContoIban', CONTO_IBAN);
}
